(async () => {
    const { Core } = await importModule('Core');
    const { Swiper } = await importModule('Swiper');
    const { 
        $show,
        $isEmpty,
        $clone,
        $fetch,
        $replaceContent
    } = await importModule('Utils');

    const RQ_SECTION = 'r_cart-notification-recommendations-swiper';

    customElements.define('cart-notification-recommendations', class extends Core {
        elements = {
            content: '[data-content]',
            spacer: '[data-spacer]',
            navPrev: '[data-nav-prev]',
            navNext: '[data-nav-next]'
        }

        async render() {
            const $doc = await $fetch('/recommendations/products', {
                params: {
                    product_id: this.productId,
                    limit: 20,
                    section_id: RQ_SECTION
                },
                select: '[data-template]'
            });

            if(!$isEmpty($doc)) {
                $replaceContent(this.$content, $doc);
                const offset = parseFloat(getComputedStyle(this.$spacer).paddingRight);
                const swiper = new Swiper(this.$content.querySelector('[data-swiper]'), {
                    // slidesPerView: 2.3,
                    spaceBetween: 10,
                    slidesOffsetBefore: offset,
                    slidesOffsetAfter: offset,
                    breakpoints: {
                        1: {
                            slidesPerView: 1.3
                        },
                        992: {
                            slidesPerView: 2.3
                        }
                    },
                    navigation: {
                        nextEl: this.$navNext,
                        prevEl: this.$navPrev,
                        disabledClass: '!disabled'
                    }
                });
                $show(this);
            }
        }

        get productId() {
            return this.getAttribute('product-id');
        }
    });
})();